<template>
  <mu-card id="sleep-input">
    <mu-card-text class="card-style" v-bind:class="{cardHasData: hasData}">
      <div v-if="loading">
        <mu-flexbox class="card-loading-padding" align="center" justify="center">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="56" color="#FFFFFF" :strokeWidth="5"></mu-circular-progress>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>
      <div v-if="!loading" class="animated fadeIn">


        <div v-if="hasWearableAndNoSelfReportedReadings || isWearableMoreRecent" @click="goToDetail">

          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.labelTimeInBed')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div class="card-large-stat">
                  <span v-text="wearableDuration"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>

          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.labelTimeAsleep')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div>
                  <span v-text="wearableAsleepDuration"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>


          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.labelTonightsPrediction')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div>
                  <span v-text="wearablePredictionDuration"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>


          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.labelEfficiency')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div>
                  <span v-text="data.wearable.efficiency + '%'"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title" v-text="$t('message.labelTimeAwake')"></mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div>
                  <span v-text="wearableTimeAwake"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
        </div>
        <div v-else>
          <mu-flexbox v-if="data.no_setting || data.error" class="card-error-padding" justify="center">
            <mu-flexbox-item align="center">
              <div class="card-notice-title" v-text="$t('message.cardEmpty')"></div>
              <div>{{ $t('message.cardTapPrefix') }}
                <mu-icon v-if="data.no_setting" class="card-icon-error" :size="16" slot="left"
                         value="settings"></mu-icon>
                <mu-icon v-if="data.error" class="card-icon-error" :size="16" slot="left" value="add"></mu-icon>
                <span v-if="data.error || data.no_setting">{{ $t('message.cardTapSuffix') }}</span>
              </div>
            </mu-flexbox-item>
          </mu-flexbox>
          <div v-else @click="goToDetail" style="cursor: pointer">
            <span v-show="false">{{hasData = true}}</span>
            <mu-content-block>
              <mu-flexbox>
                <mu-flexbox-item class="card-lite-title" v-text="$t('message.cardSleepLastNight')"></mu-flexbox-item>
                <mu-flexbox-item align="right">
                  <div class="card-large-stat">
                    <span v-text="hours"></span>
                  </div>
                </mu-flexbox-item>
              </mu-flexbox>
            </mu-content-block>
            <mu-content-block>
              <mu-flexbox>
                <mu-flexbox-item class="card-lite-title" v-text="$t('message.cardSleepAverage')"></mu-flexbox-item>
                <mu-flexbox-item align="right">
                  <div v-text="average"></div>
                </mu-flexbox-item>
              </mu-flexbox>
            </mu-content-block>
            <mu-content-block>
              <mu-flexbox>
                <mu-flexbox-item class="card-lite-title" v-text="$t('message.cardSleepQuality')"></mu-flexbox-item>
                <mu-flexbox-item align="right">
                  <div v-text="data.quality + '/10'"></div>
                </mu-flexbox-item>
              </mu-flexbox>
            </mu-content-block>
          </div>
        </div>
      </div>

    </mu-card-text>
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="12px" viewBox="20 194 16 12" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <!-- Generator: Sketch 39.1 (31720) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <path
            d="M24.2435599,197.367016 C24.2435599,196.292061 24.5552121,195.286354 25.0950382,194.418171 C25.2258208,194.208164 25.0286034,193.948647 24.7757338,194.008834 C21.8609512,194.705193 19.7527773,197.267998 20.023386,200.25082 C20.279386,203.066347 22.725299,205.364459 25.7496469,205.627858 C27.8480816,205.810684 29.7555599,205.041843 31.0439077,203.735524 C31.2178208,203.558845 31.069299,203.272148 30.8122556,203.282179 C30.7440816,203.285091 30.6748643,203.286385 30.6056469,203.286385 C27.0919077,203.286385 24.2435599,200.636535 24.2435599,197.367016 Z M28.0501686,194.238904 L28.3691251,195.090908 L29.3388643,195.110647 C29.4619947,195.113235 29.5120816,195.258202 29.4146903,195.327126 L28.6421686,195.873017 L28.9221686,196.736669 C28.9583425,196.846041 28.8251251,196.935351 28.7246034,196.870634 L27.927386,196.356131 L27.1308643,196.870634 C27.0299947,196.935675 26.8981686,196.846041 26.9329512,196.736669 L27.2129512,195.873017 L26.4404295,195.327126 C26.3430382,195.258202 26.3938208,195.113235 26.5162556,195.110647 L27.4859947,195.090908 L27.805299,194.238904 C27.8456469,194.13115 28.0094729,194.13115 28.0501686,194.238904 Z M34.0035599,200.982449 L34.3099947,201.801123 L35.2418208,201.819567 C35.3771251,201.82248 35.4327773,201.982008 35.325299,202.058051 L34.5830382,202.582585 L34.8515599,203.412261 C34.8901686,203.532311 34.7440816,203.631329 34.6334729,203.559169 L33.8679077,203.065052 L33.1026903,203.559169 C32.9920816,203.631329 32.8456469,203.532311 32.8849512,203.412261 L33.1534729,202.582585 L32.4115599,202.058051 C32.3037338,201.982331 32.3597338,201.822156 32.4943425,201.819567 L33.4261686,201.801123 L33.7336469,200.982449 C33.7781686,200.864016 33.9586903,200.864016 34.0035599,200.982449 Z M33.887386,195.047224 L34.3482556,196.276529 L35.7468643,196.304358 C35.9040816,196.307593 35.9691251,196.493332 35.8435599,196.581995 L34.7291251,197.369605 L35.133299,198.616384 C35.1788643,198.756497 35.0094729,198.87137 34.8797338,198.787561 L33.7298208,198.045253 L32.5802556,198.787561 C32.4508643,198.87137 32.2811251,198.756173 32.3266903,198.616384 L32.7305164,197.369605 L31.6157338,196.581995 C31.4912121,196.493656 31.5559077,196.30727 31.7127773,196.304358 L33.1117338,196.276529 L33.5722556,195.047224 C33.6254729,194.909376 33.8352121,194.909376 33.887386,195.047224 Z"
            id="Combined-Shape" stroke="none" fill="#183B43" fill-rule="evenodd"></path>
        </svg>
        <mu-flexbox-item class="left16" v-text="loading ? $t('message.loadingText') : title"></mu-flexbox-item>
        <mu-flexbox-item align="right" v-bind:class="{invisible: isOpen || loading}">
          <mu-icon-button
            :disabled="loading"
            v-if="!isOpenInput"
            v-tooltip.top="$t('message.addEntryText')"
            class="card-bar-icon"
            :icon="isOpenInput ? 'remove' : 'add'"
            @click.native="openInput"
          ></mu-icon-button>
          <mu-icon-button
            :disabled="loading"
            v-if="isOpenInput"
            class="card-bar-icon"
            :icon="'remove'"
            @click.native="openInput"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <transition :css="false" @enter="onToggleEnter" @leave="onToggleLeave">
      <form v-if="isOpenInput" v-on:submit.prevent="saveReading" v-bind:style="{height: computedAuto}"
            style="overflow: hidden">
        <mu-card-text>
          <mu-row>
            <mu-col width="100" tablet="50" desktop="50">
              <mu-text-field
                v-validate
                min="1"
                max="24"
                :data-vv-rules="'required|min_value:1|max_value:24'"
                data-vv-name="hours"
                data-vv-value-path="inputValue"
                :data-vv-as="$t('message.labelHours')"
                :errorText="errors.first('hours')"
                type="number"
                :label="$t('message.labelHours')"
                v-model.number="model.hours"
                :hintText="$t('message.placeholderText')"
                :fullWidth="true"
              ></mu-text-field>
            </mu-col>
          </mu-row>
          <mu-row>
            <mu-col width="100" tablet="100" desktop="100">
              <!--<mu-text-field-->
                <!--v-validate-->
                <!--data-vv-rules="required|min_value:1|max_value:10"-->
                <!--data-vv-name="quality"-->
                <!--data-vv-value-path="inputValue"-->
                <!--:data-vv-as="$t('message.cardSleepQuality')"-->
                <!--:errorText="errors.first('quality')"-->
                <!--type="number"-->
                <!--:label="$t('message.cardSleepQuality')"-->
                <!--v-model.number="model.quality"-->
                <!--:hintText="$t('message.placeholderText')"-->
                <!--:fullWidth="true"-->
              <!--/>-->
              <label class="mu-text-field-label sliderTitle" v-text="$t('message.cardSleepQuality')"></label>
              <vue-slider v-bind="sliderSettings" v-model="model.quality"></vue-slider>
              <div><span v-text="model.quality"></span>/10</div>
            </mu-col>
          </mu-row>

          <div class="bottom"></div>

          <mu-checkbox v-model="model.customDate" :label="$t('message.labelCustomDate')"></mu-checkbox>
          <date-picker v-if="model.customDate" type="datetime" v-model="model.date"></date-picker>
        </mu-card-text>
        <mu-card-actions align="right">

          <button type="submit" style="display: none"></button>

          <mu-flat-button
            :label="$t('message.discardText')"
            @click.native="closeInput"
            class="demo-flat-button"
          />
          <mu-flat-button
            @click.native="saveReading"
            type="button"
            :disabled="isSaving"
            :label="isSaving ? $t('message.savingText'): $t('message.saveText')"
            class="demo-flat-button"
          />
        </mu-card-actions>
      </form>
    </transition>

  </mu-card>
</template>
<script>

  import {TweenMax, TweenLite, Power3, ScrollToPlugin} from 'gsap/all'
  import 'gsap/ScrollToPlugin'

  const plugins = [ScrollToPlugin];

  import SleepApi from '../../../../api/Tracking/Sleep'
  import vueSlider from 'vue-slider-component/src/vue2-slider.vue'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import CardAnimationMixin from '../../../../mixins/CardAnimationMixin'
  import DatePicker from "../../../DateTimePicker/DateTimePicker.vue";


  let sliderSettings = {
    min: 1,
    max: 10,
    tooltip: 'false',
    tooltipDir: "top",
    bgStyle: {
      "backgroundColor": "#fff",
      "boxShadow": "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)"
    },
    processStyle: {
      "backgroundImage": "-webkit-linear-gradient(left, #183A43, #183A43)"
    },
    sliderStyle: [
      {
        "backgroundColor": "#CCCCCC"
      }
    ],
    value: 5
  };

  export default {
    name: 'sleep-input',
    mixins: [ScrollerMixin, CardAnimationMixin],
    components: {
      DatePicker,
      vueSlider
    },
    data() {
      return {
        title: this.$t('message.cardSleep'),
        sliderSettings: sliderSettings,
        isOpen: false,
        isOpenInput: false,
        isSaving: false,
        isBackgroundShown: true,
        hasData: false,
        noData: false,
        loading: true,
        data: {},
        model: {
          hours: 10,
          quality: 5
        }
      }
    },
    mounted() {
      let self = this;
      self.loadData();

      self.$EventBus.$on('sleepPusherReceived', function (model) {
        self.$nextTick(function () {
          self.data = model;
          self.$forceUpdate();
        });
      });

      self.$EventBus.$on('sleepReadingUpdated', function () {
        self.$store.commit('setSleepCard', {});
        self.loadData();
      });
    },
    methods: {
      saveReading() {
        let self = this;
        self.isSaving = true;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {


              if (!_.has(self.model, 'date')) {
                self.model.date = moment().format();
              }

              SleepApi.postSleepTracking(self.model)
                .then(function (response) {
                  self.$store.commit('setSleepCard', {});
                  self.$gtag.event('ReadingAdded',{
                    'event_category': 'SleepCard',
                    'event_label': 'Added reading',
                    'value': 1
                  });

                  self.$EventBus.$emit('sleepReadingAdded');

                  if (self.$route.name === 'Dashboard') {
                    TweenLite.to(self.scroller, 0.2, {
                      scrollTo: {
                        y: self.$el,
                        offsetY: 16
                      }
                    })
                  }

                  self.$toastr.success(self.$t('message.cardSleepEntryAdded'));

                  self.isSaving = false;
                  self.loadData()
                })
                .catch(function (error) {
                  self.isSaving = false;
                  self.loadData();
                })
            } else {
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      closeInput() {
        let self = this;
        self.isOpenInput = false;

        self.$gtag.event('Closed',{
          'event_category': 'SleepCard',
          'event_label': 'Closed card',
          'value': 0
        });

      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;

        if (self.isOpenInput) {
          self.$gtag.event('Open',{
            'event_category': 'SleepCard',
            'event_label': 'Opened card',
            'value': 0
          });
        }
        if (!self.isOpenInput) {
          self.$gtag.event('Closed',{
            'event_category': 'SleepCard',
            'event_label': 'Closed card',
            'value': 0
          });
        }
      },
      loadData() {
        let self = this;
        self.loading = true;
        self.isOpenInput = false;
        if (_.has(self.$store.state.cards.sleep, 'hours')) {
          self.loading = false;
          self.data = self.$store.state.cards.sleep;
        } else {
          SleepApi.getSleepTrackingCard()
            .then(function (response) {
              self.data = response.data;
              self.$store.commit('setSleepCard', response.data);
              self.loading = false
            })
            .catch(function (error) {
              self.data = error.response.data;
              self.loading = false
            })
        }
      },
      goToDetail() {
        let self = this;
        self.$router.push({
          path: '/tracking/sleep/'
        })
      }
    },
    computed: {
      wearableTimeAwake() {
        let self = this;
        let start = moment();


        let end = moment().add(self.data.wearable.minutesAwake, 'minutes');

        let diff = end.diff(start);
        let object = moment.utc(diff).toObject();


        if (self.data.wearable.minutesAwake <= 60) {
          return moment.duration(self.data.wearable.minutesAwake, 'minutes').format('m _');
        } else {
          return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
        }
      },
      wearableAsleepDuration() {
        let self = this;
        let start = moment();
        let end = moment().add(self.data.wearable.minutesAsleep, 'minutes');
        let diff = end.diff(start);
        let object = moment.utc(diff).toObject();

        if (self.data.wearable.minutesAwake <= 60) {
          return moment.duration(self.data.wearable.minutesAwake, 'minutes').format('m _');
        } else {
          return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
        }
      },
      wearablePredictionDuration() {
        let self = this;
        let start = moment();


        if (self.data.wearable.predictions.minutesAsleep <= 60) {
          return moment.duration(self.data.wearable.predictions.minutesAsleep, 'minutes').format('m _');
        } else {
          return moment.duration(self.data.wearable.predictions.minutesAsleep, 'minutes').format('h _ m _');
        }
      },
      wearableDuration() {
        let self = this;
        let start = moment(self.data.wearable.startTime);
        let end = moment(self.data.wearable.endTime);
        let diff = end.diff(start);
        let object = moment.utc(diff).toObject();

        if (self.data.wearable.minutesAwake <= 60) {
          return moment.duration(self.data.wearable.minutesAwake, 'minutes').format('m _');
        } else {
          return moment.duration(object.hours, 'hours').format('h _') + ' ' + moment.duration(object.minutes, 'minutes').format('m _');
        }
      },
      isWearableMoreRecent() {
        let self = this;
        if (self.data.wearable === false) {
          return false;
        }
        return moment(self.data.wearable.date_created).isAfter(moment(self.data.date_created));
      },
      hasWearableAndNoSelfReportedReadings() {
        let self = this;
        if (!_.has(self.data, 'wearable')) {
          return false;
        }
        return self.data.selfReportedCount === 0 && _.has(self.data, 'wearable') && _.has(self.data.wearable, 'duration');
      },

      lowercaseHoursLabel() {
        let self = this;
        return self.$t('message.labelHours').toLowerCase();
      },
      hours() {
        let self = this;
        if (self.data.hours !== undefined) {
          let humanizedHours = moment.duration(self.data.hours, 'hour').humanize();
          return humanizedHours;
        }
      },
      average() {
        let self = this;
        if (self.data.average !== undefined) {
          let humanizedHours = moment.duration(self.data.average, 'hour').humanize();
          return humanizedHours;
        }
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('sleepReadingUpdated');
      this.$EventBus.$off('sleepPusherReceived');
    }
  }
</script>
<style lang="less">
  @import "./sleep.less";
</style>



// WEBPACK FOOTER //
// Sleep.vue?45fbaa50